import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
/* empty css               */
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Breadcrumb/Breadcrumb.tsx
/**
* Where the page sits: a trail of links back up to the top level, ending at the current
* page. A navigation landmark with an ordered list; the current page has
* `aria-current="page"`.
*/
function Breadcrumb({ items, className, "aria-label": ariaLabel = "Breadcrumb", ...rest }) {
	return /* @__PURE__ */ jsx("nav", {
		className: cx("ds-breadcrumb", className),
		"aria-label": ariaLabel,
		...rest,
		children: /* @__PURE__ */ jsx("ol", {
			className: "ds-breadcrumb__list",
			children: items.map((item, index) => {
				const last = index === items.length - 1;
				const content = /* @__PURE__ */ jsxs(Fragment, { children: [item.icon, /* @__PURE__ */ jsx("span", {
					className: "ds-breadcrumb__label",
					children: item.label
				})] });
				let crumb;
				if (last) crumb = /* @__PURE__ */ jsx("span", {
					className: "ds-breadcrumb__current",
					"aria-current": "page",
					children: content
				});
				else if (item.href != null || item.as != null) {
					const Link = item.as ?? "a";
					crumb = /* @__PURE__ */ jsx(Link, {
						className: "ds-breadcrumb__link",
						href: item.href,
						onClick: item.onClick,
						children: content
					});
				} else if (item.onClick) crumb = /* @__PURE__ */ jsx("button", {
					type: "button",
					className: "ds-breadcrumb__link",
					onClick: item.onClick,
					children: content
				});
				else crumb = /* @__PURE__ */ jsx("span", {
					className: "ds-breadcrumb__text",
					children: content
				});
				return /* @__PURE__ */ jsxs("li", {
					className: "ds-breadcrumb__item",
					children: [crumb, !last && /* @__PURE__ */ jsx(Icon, {
						name: "chevron-right",
						className: "ds-breadcrumb__separator"
					})]
				}, item.key ?? item.href ?? index);
			})
		})
	});
}
//#endregion
export { Breadcrumb };

//# sourceMappingURL=Breadcrumb.js.map